import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-[#2d1a1a] text-background-100">
      <div className="section-container py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                天狼影院
              </span>
            </div>
            <p className="text-sm text-[#c4a0a0] leading-relaxed max-w-md">
              {footerData.description}
            </p>
          </div>

          {footerData.sections.map((section) => (
            <div key={section.title} className="md:col-span-3">
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-[#c4a0a0] hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              合作伙伴
            </h4>
            <p className="text-xs text-[#8a6a6a]">
              合作伙伴招募中
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#4a2a2a] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#8a6a6a]">
            &copy; 2018 - 2026 天狼影院 版权所有
          </p>
          <p className="text-xs text-[#8a6a6a]">
            天狼影院电视剧全集连播 - 最新剧集高清免费在线观看
          </p>
        </div>
      </div>
    </footer>
  );
}